export class ApiError extends Error {
  public readonly timestamp: number;

  constructor(
    public readonly code: number,
    public readonly text: string,
  ) {
    super(`[${code}]: ${text}`);

    this.code = code;
    this.message = text;
    this.timestamp = Date.now();
  }

  override toString() {
    return `[${this.code}]: ${this.text}`;
  }
}

export class ApiDataError extends Error {
  constructor(
    public readonly code: number,
    public readonly text: string,
  ) {
    super(`[${code}]: ${text}`);
  }
}

// replacement for ApiError for transport errors (4xx, 5xx, network errors, etc.)
export class TransportError extends Error {
  public readonly timestamp: number;

  constructor(
    public readonly code: number,
    public readonly text: string,
  ) {
    super(`[${code}]: ${text}`);

    this.code = code;
    this.message = text;
    this.timestamp = Date.now();
  }

  override toString() {
    return `[${this.code}]: ${this.text}`;
  }
}
